export namespace AESStorageProps {
	export enum Type {
		local = 'localStorage',
		session = 'sessionStorage',
	}

	export interface Options {
		type: Type;
	}
}
